/**
 * SKINriched — Website Lead Capture Form (POPUP)
 * Pure-JS version of the LeadConnector iframe embed.
 *
 * Sizing:
 *   Desktop (>768px) → 50vw × 70vh, centered
 *   Mobile  (≤768px) → full width, inset from the top so the close control clears
 *
 * FIX 1 (dismiss bug): the backdrop previously carried `display:flex !important`,
 * which outranks the inline `display:none` LeadConnector applies on close. The
 * invisible backdrop stayed full-screen and swallowed every click on the page.
 * Flex is now on a JS-toggled state class, plus an explicit teardown.
 *
 * FIX 2 (no exit on mobile): a 100vw × 100vh card with overflow:hidden clipped
 * LeadConnector's own close button off the screen, trapping mobile visitors.
 * The card is now inset below a reserved strip, and we render our own close
 * button on the backdrop — outside the card, so it can never be clipped.
 *
 * Drop this anywhere JS runs: site footer, GTM Custom HTML tag, theme JS file.
 */
(function () {
  var FORM_ID   = "rMTwn7PLvKmkUushJYVk";
  var IFRAME_ID = "popup-" + FORM_ID;
  var FORM_SRC  = "https://link.skinrichedclinic.com/widget/form/" + FORM_ID;
  var EMBED_JS  = "https://link.skinrichedclinic.com/js/form_embed.js";
  var MOBILE_BP = 768;

  var DISMISS_DAYS = 7;                          // match data-deactivation-value
  var STORE_KEY    = "sr-popup-dismissed-until";

  var CARD    = "sr-popup-card";    // the visible white box — carries the target size
  var FILL    = "sr-popup-fill";    // anything between card and iframe — 100%/100%
  var OVERLAY = "sr-popup-overlay"; // the full-screen backdrop — centers the card
  var OPEN    = "sr-popup-open";    // present ONLY while the popup is actually shown
  var CLOSE   = "sr-popup-close";   // our own always-visible close button

  var MOBILE_TOP_GAP = 56;          // px reserved above the card on mobile

  var overlayEl = null;             // cached reference to the backdrop

  /* ---------- helpers ---------- */

  function isMobile() {
    return window.matchMedia("(max-width:" + MOBILE_BP + "px)").matches;
  }

  function modalHeightPx() {
    return isMobile()
      ? Math.max(320, window.innerHeight - MOBILE_TOP_GAP)
      : Math.round(window.innerHeight * 0.7);
  }

  // Read the element's INLINE style only. Computed style is useless here because
  // our own stylesheet would report flex even after LeadConnector hides it.
  function hiddenInline(el) {
    if (!el) return true;
    var inline = (el.getAttribute("style") || "").replace(/\s+/g, "").toLowerCase();
    return inline.indexOf("display:none") !== -1 ||
           inline.indexOf("visibility:hidden") !== -1;
  }

  function popupIsOpen() {
    var iframe = document.getElementById(IFRAME_ID);
    if (!iframe) return false;
    if (hiddenInline(iframe)) return false;
    if (overlayEl && hiddenInline(overlayEl)) return false;
    return iframe.getBoundingClientRect().height > 0;
  }

  function suppressedUntil() {
    try {
      return parseInt(window.localStorage.getItem(STORE_KEY), 10) || 0;
    } catch (e) {
      return 0;
    }
  }

  function rememberDismiss() {
    try {
      var until = Date.now() + DISMISS_DAYS * 24 * 60 * 60 * 1000;
      window.localStorage.setItem(STORE_KEY, String(until));
    } catch (e) { /* private mode — non-fatal */ }
  }

  /* ---------- CSS ---------- */

  function injectStyles() {
    if (document.getElementById("sr-popup-styles")) return;

    var css = [
      /* Backdrop centering ONLY applies while the popup is open. Without the
         .sr-popup-open guard, `display:flex !important` would override the
         inline `display:none` that LeadConnector sets on dismiss, leaving an
         invisible full-screen layer that blocks all clicks on the site. */
      "." + OVERLAY + "." + OPEN + "{",
      "  display:flex !important;",
      "  align-items:center !important;",
      "  justify-content:center !important;",
      "}",

      /* Belt and braces: a backdrop without the open flag is fully inert. */
      "." + OVERLAY + ":not(." + OPEN + "){",
      "  display:none !important;",
      "  pointer-events:none !important;",
      "}",

      /* the card — the ONE element that carries the target size */
      "." + CARD + "{",
      "  position:relative !important;",
      "  top:auto !important; left:auto !important;",
      "  right:auto !important; bottom:auto !important;",
      "  transform:none !important;",
      "  margin:auto !important;",
      "  width:50vw !important;",
      "  height:70vh !important;",
      "  min-width:380px !important;",
      "  max-width:100vw !important;",
      "  max-height:100vh !important;",
      "  border-radius:8px !important;",
      "  overflow:hidden !important;",
      "}",

      /* every layer inside the card, including the iframe, fills it edge to edge */
      "." + FILL + "{",
      "  width:100% !important;",
      "  height:100% !important;",
      "  min-width:0 !important;",
      "  max-width:none !important;",
      "  max-height:none !important;",
      "  top:0 !important; left:0 !important;",
      "  transform:none !important;",
      "  margin:0 !important;",
      "  border:none !important;",
      "  border-radius:0 !important;",
      "}",

      /* --- our own close button: lives on the BACKDROP, never inside the card,
             so the card's overflow:hidden can't clip it --- */
      "." + CLOSE + "{",
      "  position:fixed !important;",
      "  top:12px !important;",
      "  right:12px !important;",
      "  z-index:2147483647 !important;",
      "  width:44px !important;",
      "  height:44px !important;",
      "  padding:0 !important;",
      "  margin:0 !important;",
      "  display:flex !important;",
      "  align-items:center !important;",
      "  justify-content:center !important;",
      "  border:none !important;",
      "  border-radius:50% !important;",
      "  background:rgba(35,21,22,0.72) !important;",
      "  color:#ffffff !important;",
      "  font-family:Arial,Helvetica,sans-serif !important;",
      "  font-size:24px !important;",
      "  line-height:1 !important;",
      "  cursor:pointer !important;",
      "  -webkit-appearance:none !important;",
      "  appearance:none !important;",
      "  box-shadow:0 2px 8px rgba(0,0,0,0.3) !important;",
      "}",
      "." + CLOSE + ":focus{ outline:2px solid #ffffff !important; outline-offset:2px !important; }",

      /* Mobile: reserve a strip at the top so the card never fills the screen
         edge to edge, and the close control always has somewhere to sit. */
      "@media (max-width:" + MOBILE_BP + "px){",
      "  ." + OVERLAY + "." + OPEN + "{",
      "    align-items:flex-end !important;",
      "  }",
      "  ." + CARD + "{",
      "    width:100vw !important;",
      "    height:calc(100vh - " + MOBILE_TOP_GAP + "px) !important;",
      "    height:calc(100dvh - " + MOBILE_TOP_GAP + "px) !important;",
      "    min-width:0 !important;",
      "    margin:0 !important;",
      "    border-radius:14px 14px 0 0 !important;",
      "  }",
      "  ." + CLOSE + "{",
      "    top:8px !important;",
      "    right:10px !important;",
      "    width:40px !important;",
      "    height:40px !important;",
      "  }",
      "}"
    ].join("\n");

    var style = document.createElement("style");
    style.id = "sr-popup-styles";
    style.appendChild(document.createTextNode(css));
    document.head.appendChild(style);
  }

  /* ---------- our own close button ---------- */

  function ensureCloseButton() {
    if (document.querySelector("." + CLOSE)) return;

    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = CLOSE;
    btn.setAttribute("aria-label", "Close");
    btn.innerHTML = "&times;";

    btn.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      closePopup();
    });

    document.body.appendChild(btn);
  }

  function removeCloseButton() {
    var btn = document.querySelector("." + CLOSE);
    if (btn && btn.parentNode) btn.parentNode.removeChild(btn);
  }

  function closePopup() {
    var iframe = document.getElementById(IFRAME_ID);
    if (iframe) iframe.style.display = "none";
    if (overlayEl) {
      overlayEl.classList.remove(OPEN);
      overlayEl.style.display = "none";
      overlayEl.style.pointerEvents = "none";
    }
    removeCloseButton();
    document.body.style.overflow = "";
    document.documentElement.style.overflow = "";
    rememberDismiss();
  }

  /* ---------- teardown: hand the page back to the user ---------- */

  function teardown() {
    if (overlayEl) {
      overlayEl.classList.remove(OPEN);
      overlayEl.style.pointerEvents = "none";
    }
    removeCloseButton();
    // LeadConnector locks scroll behind the modal; make sure it is released.
    document.body.style.overflow = "";
    document.documentElement.style.overflow = "";
  }

  /* ---------- find the real card and size the whole chain ---------- */

  function applyLayout() {
    var iframe = document.getElementById(IFRAME_ID);
    if (!iframe) return;

    if (!popupIsOpen()) {
      teardown();
      return;
    }

    var vw = window.innerWidth;
    var vh = window.innerHeight;
    var chain = [];
    var node = iframe.parentElement;

    // Walk up until we hit the full-screen backdrop (or body)
    while (node && node !== document.body) {
      var coversViewport =
        node.offsetWidth >= vw * 0.97 && node.offsetHeight >= vh * 0.97;

      if (coversViewport) {
        overlayEl = node;
        node.classList.add(OVERLAY);
        node.classList.add(OPEN);
        node.style.pointerEvents = "";
        break;
      }
      chain.push(node);
      node = node.parentElement;
    }

    if (chain.length) {
      // Outermost wrapper is the card; everything below it just fills
      chain.forEach(function (el, i) {
        var isCard = i === chain.length - 1;
        el.classList.toggle(CARD, isCard);
        el.classList.toggle(FILL, !isCard);
      });
      iframe.classList.add(FILL);
      iframe.classList.remove(CARD);
    } else {
      // Iframe sits directly on the backdrop — it IS the card
      iframe.classList.add(CARD);
      iframe.classList.remove(FILL);
    }

    // The popup is genuinely on screen — guarantee an exit.
    ensureCloseButton();
  }

  /* ---------- build ---------- */

  function init() {
    if (document.getElementById(IFRAME_ID)) return;
    if (Date.now() < suppressedUntil()) return;   // dismissed recently

    injectStyles();

    var iframe = document.createElement("iframe");
    iframe.src = FORM_SRC;
    iframe.id = IFRAME_ID;
    iframe.title = "Website Lead Capture Form";
    // No hard-coded size here — applyLayout() decides once the DOM exists
    iframe.style.cssText = "display:none;border:none";

    var attrs = {
      "data-layout":             "{'id':'POPUP'}",
      "data-trigger-type":       "showAfter",
      "data-trigger-value":      "1",
      "data-activation-type":    "alwaysActivated",
      "data-activation-value":   "",
      "data-deactivation-type":  "deactivateAfter",
      "data-deactivation-value": String(DISMISS_DAYS),
      "data-form-name":          "Website Lead Capture Form",
      "data-height":             "1233",
      "data-layout-iframe-id":   IFRAME_ID,
      "data-form-id":            FORM_ID,
      "data-modal-height":       String(modalHeightPx())
    };

    Object.keys(attrs).forEach(function (key) {
      iframe.setAttribute(key, attrs[key]);
    });

    document.body.appendChild(iframe);

    // Re-apply whenever LeadConnector rebuilds or restyles its wrapper
    if (window.MutationObserver) {
      var scheduled = false;
      var observer = new MutationObserver(function () {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(function () {
          scheduled = false;
          applyLayout();
        });
      });
      observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ["style", "class"]
      });
    }

    // LeadConnector posts a message when the form is closed or submitted.
    window.addEventListener("message", function (e) {
      var d = e && e.data;
      var s = typeof d === "string" ? d : (d && (d.type || d.event)) || "";
      if (/close|hide|dismiss/i.test(String(s))) {
        setTimeout(function () { closePopup(); }, 50);
      } else if (/submit/i.test(String(s))) {
        // Let the thank-you state show, then release the page.
        setTimeout(function () { applyLayout(); }, 50);
      }
    });

    // Escape key should also release the page.
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" || e.keyCode === 27) {
        if (popupIsOpen()) closePopup();
      }
    });

    var resizeTimer;
    window.addEventListener("resize", function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        var el = document.getElementById(IFRAME_ID);
        if (el) el.setAttribute("data-modal-height", String(modalHeightPx()));
        applyLayout();
      }, 150);
    });

    if (!document.querySelector('script[src="' + EMBED_JS + '"]')) {
      var script = document.createElement("script");
      script.src = EMBED_JS;
      script.async = true;
      document.body.appendChild(script);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();